import { ConsentSettingsClickedEventHandler } from './ConsentSettingsClickedEvent';

export * from './ConsentSettingsClickedEvent';

export const cookieConsentEventHandlers = [ConsentSettingsClickedEventHandler];
